import Page from "@/Pages/Page";
import {relativeRoute} from "@/helpers/relativeRoute";
import imageAdressBook from "@images/media/addresses-page.png";

export default function Advertise(){

  return <Page title={'Adverteren'} harvestId={135}>
    <section className="article">
      <div>

        <h1 className="pt-5">Adverteren op Mensenlinq.nl</h1>

        <div className="card__content">
          <img src={imageAdressBook} alt="Adverteren op Mensenlinq.nl"/>
          <br/>


          <p>
            Mensenlinq.nl is marktleider in Nederland op het gebied van online rouwen en reageren. We bieden
            verschillende manieren om je product of dienst onder de aandacht te brengen bij een groot geïnteresseerd en
            relevant publiek. Met meer dan 700 bezoekers per maand is onze website of
            onze <a href={relativeRoute('adressengids')}>adressengids</a> dé plek waar jouw bedrijf zich online
            kan profileren.
          </p>
          <h2 className="pt-5">Vermelding in adressengids</h2>
          <p>In de adressengids kun je zichtbaar zijn met de bedrijfsnaam, logo, introductietekst, adresgegevens en de
            URL van jouw eigen website. Dit geeft jou een unieke kans om jezelf te presenteren aan een breed publiek en
            de online zichtbaarheid van jouw bedrijf te vergroten. Potentiële klanten kunnen gemakkelijk contact met je
            opnemen, terwijl bestaande klanten snel jouw gegevens kunnen vinden.</p>

          <h2 className="pt-5">Advertentie op Mensenlinq.nl</h2>
          <p>Je kunt er ook voor kiezen om middels een advertentie zichtbaar te zijn op onze website.
            De advertentieblokken over de gehele Mensenlinq-website (bijvoorbeeld naast de rouwadvertenties) worden
            opgevuld met advertenties van verschillende adverteerders, die rouleren in een carrousel.
            Jouw advertentie kan hierin worden opgenomen, wat zorgt voor extra zichtbaarheid en naamsbekendheid bij de doelgroep.
            De advertentie is klikbaar en leidt direct naar de URL die jij opgeeft.</p>

          <h2 className="pt-5">Hét informatieplatform rondom overlijden</h2>


          <p>Mensenlinq.nl is de enige site die nieuwsberichten rond de dood brengt, samen met de gepubliceerde
            overlijdensberichten uit de aangesloten printpublicaties en de door bezoekers geplaatste condoleances. Ook
            de redactionele samenwerking met verschillende kranten en weekbladen is uniek.</p>

          <p>Voor iedereen die meer wil weten over het onderwerp overlijden en wat daarbij komt kijken, is Mensenlinq de
            plek om verhalen, informatie en praktische zaken te lezen. Van alle online bezoekers is 55% nieuwsgierig wie
            er in zijn of haar regio overleden is. Door te adverteren op onze website of zichtbaar te zijn in de
            adressengids ben je gelijk zichtbaar onder een relevant publiek.</p>

          <h2 className="pt-5">Adverteren?</h2>
          <p>Voor adverteren (zakelijk) op Mensenlinq of een vermelding in de adressengids kun je contact opnemen
            met: </p>
          <p>Ina Hidding<br/>
            T <a href="tel:06 5202 7637">06 5202 7637</a><br/>
            I <a href="mailto:ina.hidding@mediahuisnoord.nl">ina.hidding@mediahuisnoord.nl</a><br/>
            Fedde Kingma<br/>
            T <a href="tel:0651154961">06 5115 4961</a><br/>
            I <a href="mailto:fedde.kingma@mediahuisnoord.nl">fedde.kingma@mediahuisnoord.nl</a></p>
          <p><a href="https://www.mediahuisnoord.nl/verkoopvoorwaarden/">Algemene voorwaarden adverteren</a></p>
        </div>
      </div>
    </section>
  </Page>
}
